import { render, staticRenderFns } from "./CsWidgetChatEditor.vue?vue&type=template&id=5d5e33ee&scoped=true&"
import script from "./CsWidgetChatEditor.vue?vue&type=script&lang=js&"
export * from "./CsWidgetChatEditor.vue?vue&type=script&lang=js&"
import style0 from "./CsWidgetChatEditor.vue?vue&type=style&index=0&id=5d5e33ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e33ee",
  null
  
)

export default component.exports